module.exports = __webpack_public_path__ + "img/noRight.7d63a068.png";